// English translations for playerholder3 module
export const messages = {
    "Player": "Player",
    "Status": "Status",
    "Instructions Title": "Instructions Title",
    "Instructions": "Instructions",
    "Offline": "Offline",
    "Initializing": "Initializing",
    "Online": "Online"
}

